import { use } from "react";
import { ThemeContext } from "../context/theme/ThemeContext";

export type ThemeSetting = "light" | "dark" | "system";

export const THEME_LOCAL_STORAGE_KEY = "theme";

const useTheme = () => {
    const { theme, resolvedTheme, setTheme } = use(ThemeContext);

    return {
        theme, // light | dark | system
        resolvedTheme, // light | dark
        setTheme,
    };
};

export default useTheme;
